// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import VueClipboard from 'vue-clipboard2'
import VueLogger from 'vuejs-logger'

import HTTP from '@/service/httpservice'
const clauseDao = new HTTP('/v1/clauses')
const documentDao = new HTTP('/document/base64')

const options = {
  isEnabled: true,
  logLevel: 'debug',
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: '|',
  showConsoleColors: true
}
Vue.use(VueLogger, options)
Vue.use(VueClipboard)
Vue.config.productionTip = false

const Office = window.Office
Office.initialize = (reason) => {
  new Vue({
    el: '#app',
    components: { App },
    template: '<App/>'
  })
  console.log('FUNCTIONS_READY', reason)
}

// Your function must be in the global namespace.
function replaceClauseHyperlinks (event) {
  OfficeExtension.config.extendedErrorLogging = true
  Word.run(async function (ctx) {
    const range = ctx.document.getSelection()
    await ctx.sync()
    ctx.load(range, 'text')
    await ctx.sync()
    const trimmed = range.text.trim()
    console.log(trimmed)
    try {
      const split = trimmed.split('@')
      const id = split[split.length - 1]
      console.log('ID: ' + id)
      const res = await documentDao.get(id).then(res => res.data)
      const base64 = res
      ctx.load(range)
      await ctx.sync()
      range.insertFileFromBase64(base64, 'replace')
      await ctx.sync()
      const clause = await clauseDao.get(id).then(res => res.data)
      console.log('KLAUSEL:', clause)
      window.analytics.track('[ADD-IN] REPLACE CLAUSE HYPERLINK - ' + clause.name, {
        id: clause.id,
        name: clause.name
      })
    } catch (e) {
      // console.log('Error: ' + JSON.stringify(e))
      if (e instanceof OfficeExtension.Error) {
        // Alert.Show('Debug info: ' + JSON.stringify(e.debugInfo))
      }
      Alert.Show('No clause found')
    }
    event.completed()
  })
}

window.replaceClauseHyperlinks = replaceClauseHyperlinks



// WEBPACK FOOTER //
// ./src/main.js